import _ from 'underscore';

const templateList = [
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000000',
    templateName: '300x250 - Circle cta',
    version: '1.0',
    style: 1,
    width: 300,
    height: 250,
    templateFileName: '300x250_1.91_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 30,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 90,
    },
    description: {
      display: false,
      maxLengthInChar: 170,
    },
    cta: {
      display: false,
      maxLengthInChar: 0,
    },
    image: {
      aspectRatio: '1.91:1',
      minheight: 157,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000001',
    templateName: '320x50 - Title Only',
    version: '1.0',
    style: 1,
    width: 320,
    height: 50,
    templateFileName: '320x50_1.91_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 30,
    },
    description: {
      display: false,
      maxLengthInChar: 170,
    },
    cta: {
      display: false,
      maxLengthInChar: 0,
    },
    image: {
      aspectRatio: '1.91:1',
      minheight: 50,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000003',
    templateName: '728x90 - Title Only',
    version: '1.0',
    style: 1,
    width: 728,
    height: 90,
    templateFileName: '728x90_1.91_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 40,
    },
    description: {
      display: true,
      maxLengthInChar: 54,
    },
    cta: {
      display: false,
      maxLengthInChar: 0,
    },
    image: {
      aspectRatio: '1.91:1',
      minheight: 90,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000004',
    templateName: '300x600 - Square cta + description ',
    version: '1.0',
    style: 1,
    width: 300,
    height: 600,
    templateFileName: '300x600_1.91_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 50,
    },
    description: {
      display: true,
      MinLengthInChar: 60,
      maxLengthInChar: 170,
    },
    cta: {
      display: true,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1.91:1',
      minheight: 157,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000005',
    templateName: '970x250 - Learn More cta',
    version: '1.0',
    style: 1,
    width: 970,
    height: 250,
    templateFileName: '970x250_1.91_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 80,
    },
    description: {
      display: true,
      maxLengthInChar: 166,
    },
    cta: {
      display: true,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1.91:1',
      minheight: 250,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000006',
    templateName: '336x280 - Title Only',
    version: '1.0',
    style: 1,
    width: 336,
    height: 280,
    templateFileName: '336x280_1.91_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 80,
    },
    description: {
      display: false,
      maxLengthInChar: 120,
    },
    cta: {
      display: false,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1.91:1',
      minheight: 176,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000007',
    templateName: '320x50 - 1:1 asset',
    version: '1.0',
    style: 1,
    width: 320,
    height: 50,
    templateFileName: '320x50_1_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 38,
    },
    description: {
      display: false,
      maxLengthInChar: 170,
    },
    cta: {
      display: false,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1:1',
      minheight: 50,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000008',
    templateName: '728x90 - 1:1 Circle cta',
    version: '1.0',
    style: 1,
    width: 728,
    height: 90,
    templateFileName: '728x90_1_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 60,
    },
    longHeadline: {
      display: true,
      MinLengthInChar: 34,
      maxLengthInChar: 60,
    },
    description: {
      display: true,
      MinLengthInChar: 30,
      maxLengthInChar: 74,
    },
    cta: {
      display: false,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1:1',
      minheight: 90,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-000000000009',
    templateName: '300x600 - 1:1 description',
    version: '1.0',
    style: 1,
    width: 300,
    height: 600,
    templateFileName: '300x600_1_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 60,
    },
    description: {
      display: true,
      MinLengthInChar: 30,
      maxLengthInChar: 150,
    },
    cta: {
      display: true,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1:1',
      minheight: 300,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-00000000000a',
    templateName: '160x600 - Learn More cta',
    version: '1.0',
    style: 1,
    width: 160,
    height: 600,
    templateFileName: '160x600_1_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 20,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 70,
    },
    description: {
      display: true,
      maxLengthInChar: 100,
    },
    cta: {
      display: true,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1:1',
      minheight: 160,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-00000000000b',
    templateName: '970x250 - 1:1 Learn More cta + description',
    version: '1.0',
    style: 1,
    width: 970,
    height: 250,
    templateFileName: '970x250_1_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 60,
    },
    longHeadline: {
      display: true,
      MinLengthInChar: 50,
      maxLengthInChar: 120,
    },
    description: {
      display: true,
      MinLengthInChar: 80,
      maxLengthInChar: 180,
    },
    cta: {
      display: true,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1:1',
      minheight: 250,
    },
  },
  {
    thisTemplateId: '00000000-0000-0000-0000-00000000000c',
    templateName: '320x100 - Title Only',
    version: '1.0',
    style: 1,
    width: 320,
    height: 100,
    templateFileName: '320x100_1_1.html',
    shortHeadline: {
      display: true,
      maxLengthInChar: 30,
    },
    longHeadline: {
      display: true,
      maxLengthInChar: 78,
    },
    description: {
      display: false,
      maxLengthInChar: 180,
    },
    cta: {
      display: false,
      Upper: true,
      maxLengthInChar: 20,
    },
    image: {
      aspectRatio: '1:1',
      minheight: 100,
    },
  },
];

export const getMaxLengthOfTemplateMeta = (thisTemplateId, thisTemplateVersion, aigcTemplateList) => {
  let maxLengthInfo = {};
  const templates = aigcTemplateList !== null && aigcTemplateList !== undefined ? aigcTemplateList : templateList;

  _.map(templates, (template) => {
    if (template.templateId === thisTemplateId && template.version === thisTemplateVersion) {
      maxLengthInfo = {
        shortHeadline: template.shortHeadline.maxLengthInChar,
        longHeadline: template.longHeadline.maxLengthInChar,
        description: template.description.maxLengthInChar,
        cta: template.cta.maxLengthInChar,
      };
    }
  });

  return maxLengthInfo;
};
